import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
interface ViewModeProps {
  editmode?: boolean;
}

const ViewMode: React.FC<ViewModeProps> = ({editmode}) => {
  const navigate = useNavigate()
  const {pathname} = useLocation()

  useEffect(() => {
    const legacyProfileUrl = pathname.replace('/attorney','')
    navigate(legacyProfileUrl)
  }, []);

  return (
    <>
    </>
  );
};

export default ViewMode;
